import React from "react";
import { Box } from "@mui/material";
import NameMatchingRow from "./NameMatchingRow";

export default function MatchingParameter({ items, values, onSliderChange }) {
  return (
    <Box>
      {items.map((item) => {
        return (
          <NameMatchingRow key={item.label} rowData={item} values={values} onSliderChange={onSliderChange(item)} />
        );
      })}
    </Box>
  );
}
